import React, { useState, useEffect, forwardRef } from 'react'
import $ from 'jquery';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/register_template/Attendance_Override.xlsx"
import { uploadAttendanceRegisterOverride, multiDeleteAttendanceRegisterOverrideFile, getAttendanceRegisterOverride } from './../../../../services/register_redux/register_actions/AttendanceRegisterOverride.action';
import { useDispatch, useSelector } from 'react-redux';
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/Attendance Override/mainicon.png"
import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import Branch_id_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Branch_id_icon.png"
import Client_id_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Client_id_icon.png"
import Current_Month_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Current_Month_icon.png"
import Employee_code_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Employee_code_icon.png"
import Employee_name_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Employee_name_icon.png"
import Maternity_Leave_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Maternity_Leave_icon.png"
import Paid_leave_balance_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Paid_leave_balance_icon.png"
import Paid_leave_taken_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Paid_leave_taken_icon.png"
import Paid_leave_total_avalable_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Paid_leave_total_avalable_icon.png"
import sick_leave_balance_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/sick_leave_balance_icon.png"
import Sick_leave_for_the_month_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Sick_leave_for_the_month_icon.png"
import Total_leave_days_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Total_leave_days_icon.png"
import Sick_leave_opening_balance_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Sick_leave_opening_balance_icon.png"
import Sick_leave_total_available_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Sick_leave_total_available_icon.png"
import Sick_leave_taken_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Sick_leave_taken_icon.png"
import Paid_leave_for_the_month_icon from "../../../../assets/register_assets/inputMatix/Attendance Override/Paid_leave_for_the_month_icon.png"
import Icon from '@mui/material/Icon';


const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function AttendanceOverride({ setLoading, showSnackbar }) {
    const [checkedItems, setCheckedItems] = useState({});
    const [data, setGetData] = useState([])
    const [uploadFormVisible, setuploadVisible] = useState(false);
    const [file, setFile] = useState([])
    const [createData, setCreateData] = useState(null);
    const [opendeletemultialert, setopendeletemultialert] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const dispatch = useDispatch();
    const { date } = useParams();
    const current_month = date;
    const handleSearchClick = (e) => {
        e.preventDefault();
        const value = $('#searchInput').val().toLowerCase();
        $('#dataTable tbody tr').each(function () {
            const rowText = $(this).text().toLowerCase();
            const isVisible = rowText.includes(value);
            $(this).toggle(isVisible);
        });
    };

    const handleFileUploaddata = (e) => {
        handleFileUpload()
        setuploadVisible(!uploadFormVisible)
    };
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getAttendanceRegisterOverride(date));
            const arr = response?.data?.attendance_override;
            const data = Array.isArray(arr) ? arr : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch attendance override:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);

    
    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    //             const response = await dispatch(uploadAttendanceRegisterOverride(file));
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message.error, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', error);
    //             setLoading(false);
    //         }
    //     }
    // };


const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'attendance_override_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadAttendanceRegisterOverride(file));
        console.log("Upload attendance ovrride response:", response);
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            setActionChecked("create");
            
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.inserted_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};





    const handledeletemultialert = (e) => {
        e.preventDefault()
        setopendeletemultialert(true)
    }
    const selectedDelete = (e) => {
        e.preventDefault();
        const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
        setopendeletemultialert(false)
        const selectedid = { ids: selectedIds };
        submitdelete(selectedid);
    };
    const handledeletemultiClosealert = () => {
        setopendeletemultialert(false)
        setCheckedItems({})
    }
    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteAttendanceRegisterOverrideFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata()
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }
    const handleCheckChange = (id) => {
        setCheckedItems(prevCheckedItems => ({
            ...prevCheckedItems,
            [id]: !prevCheckedItems[id]
        }));
    };
    const handleCheckAll = () => {
        const newCheckedItems = {};
        data.forEach(item => {
            newCheckedItems[item.id] = !isAllChecked;
        });
        setCheckedItems(newCheckedItems);
    };
    const calculateWidth = (text) => {
        const charWidth = 10;
        return `${text.length * charWidth}px`;
    };
    const generateMonthHeaders = (year, month) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthIndex = month - 1; // Convert to zero-based index
        const lastDay = new Date(year, month, 0).getDate();

        const headers = [];
        for (let day = 1; day <= lastDay; day++) {
            const dayString = day.toString().padStart(2, '0');
            headers.push({ key: `day_${dayString}`, value: `${monthNames[monthIndex]}-${dayString}`,icon:Current_Month_icon });
            
        }

        return headers;
    };
    const [year, month] = date.split('-').map(part => parseInt(part, 10));
    const dateHeaders = generateMonthHeaders(year, month);
    const existingHeaders = [
        { key: "emp_code", value: "Employee Code" , readOnly:true  ,icon: Employee_code_icon},
        { key: "emp_Name", value: "Employee Name" , readOnly:true  ,icon: Employee_name_icon},
        { key: "client_id", value: "Organization ID",readOnly:true  ,icon: Client_id_icon},
        { key: "unit_id", value: "Branch ID" ,readOnly:true ,icon: Branch_id_icon},
        { key: "current_month", value: "Current Month" ,icon: Current_Month_icon},
        { key: "sick_leaves_opening_balance", value: "Sick Leaves Opening Balance" ,icon: Sick_leave_opening_balance_icon},
        { key: "sick_leave_eligible_for_month", value: "Sick Leave Eligible For The Month" ,icon: Sick_leave_for_the_month_icon},
        { key: "sick_leave_total_available", value: "Sick Leave Total Available" ,icon: Sick_leave_total_available_icon},
        { key: "sick_leaves_taken", value: "Sick Leaves Taken" ,icon: Sick_leave_taken_icon},
        { key: "sick_leave_balance", value: "Sick Leave Balance" , icon: sick_leave_balance_icon},
        { key: "paid_leaves_opening_balance", value: "Paid Leaves Opening Balance" ,icon: Paid_leave_balance_icon},
        { key: "paid_leave_eligible_for_month", value: "Paid Leave Eligible for Month" ,icon: Paid_leave_for_the_month_icon},
        { key: "paid_leave_total_available", value: "Paid Leave Total Available" ,icon: Paid_leave_total_avalable_icon},
        { key: "paid_leaves_taken", value: "Paid Leaves Taken" , icon: Paid_leave_taken_icon},
        { key: "paid_leave_balance", value: "Paid Leave Balance" ,icon: Paid_leave_balance_icon},
        { key: "maternity_leave", value: "Maternity Leave" ,icon: Maternity_Leave_icon},
        { key: "casual_leave_eligible_for_month", value: "Casual Leave Eligible for Month" ,icon: Maternity_Leave_icon},
        { key: "casual_leaves_opening_balance", value: "Casual Leaves Opening Balance" ,icon: Maternity_Leave_icon},
        { key: "casual_leaves_taken", value: "Casual Leaves Taken" ,icon: Maternity_Leave_icon},
        { key: "casual_leave_balance", value: "Casual Leave Balance" ,icon: Maternity_Leave_icon},
        { key: "casual_leave_total_available", value: "Casual Leave Total Available" ,icon: Maternity_Leave_icon},
        { key: "total_leave_days", value: "Total Leave Days" ,icon: Total_leave_days_icon},
    ];

    const [actionChecked, setActionChecked] = useState("");

    const header = [...existingHeaders, ...dateHeaders];
    const updateCheckAllState = () => {
        const allChecked = data.length > 0 && data.every(item => checkedItems[item.id]);
        setIsAllChecked(allChecked);
    };

    useEffect(() => {
        updateCheckAllState();
    }, [checkedItems]);


    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Employee Master');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);

    return (
        <div className="container-fluid">
            {/* <div className="col-md-12 py-3">
                <div className="card bg-white">
                    <div className="card-header card-header-color py-0">
                        <div className="col-md-12">
                            <div className="row client-form-header d-flex">
                                <div className="col-md-6 pt-2">
                                    <h6 className='text-dark'>Attendance Register Override</h6>
                                </div>
                                <div className="col-md-6">
                                    <a href={`/input-matrix/${current_month}`} className='text-dark'><i className="bi bi-x float-end cancel-icon"></i></a>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row justify-content-between">
                                    <div className="col-md-9">
                                        <button
                                            className="btn btn-info text-white me-3 mt-3"
                                            onClick={() => setuploadVisible(!uploadFormVisible)}
                                        >
                                            <b>Import Attendance Register Override</b>
                                        </button>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="row">
                                            <div className="col-md-12 float-end">
                                                <form action="">
                                                    <div className=" d-flex search-div float-end m-0">
                                                        <input
                                                            type="text"
                                                            placeholder="Search..."
                                                            id="searchInput"
                                                            className='bg-light headerXsm'
                                                        />
                                                        <button onClick={handleSearchClick} className='search-submit bg-light'><i className="bi bi-search"></i></button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    {uploadFormVisible && (
                                        <div className='col-md-5'>
                                            <div className="row">
                                                <div className="card p-0 m-3">
                                                    <div className="card-header pe-0 ">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <h6>Import file</h6>
                                                                </div>
                                                                <div className="col-md-2 float-end cursor-pointer pe-4">
                                                                    <i className="bi bi-x float-end p-0" onClick={() => setuploadVisible(!uploadFormVisible)}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="mb-3">
                                                            <label for="formFile" className="form-label"><b>Import File</b></label>

                                                            <a href={files} download="Attendance Override.xlsx" className='float-end'>
                                                                template
                                                            </a>
                                                            <input className="form-control" type="file" id="formFile" onChange={handleFileChange} accept=".xls,.xlsx" />
                                                        </div>
                                                        <div className='float-end'>
                                                            <button className='btn btn-success btn-sm' onClick={handleFileUploaddata} type='submit'>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                </div>
                                <div className="card mt-0">
                                    <form onSubmit={handledeletemultialert}>
                                        <div className="card-header">
                                            <div className="col-md-12">
                                                <div className="row justify-content-between">
                                                    <div className="col-md-6">
                                                        <p className='pt-1 m-0 client-2nd-header-size'>Selected Entries: </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row float-end">
                                                            <p className='col-md-11 pt-1 client-2nd-header-size m-0'>Total Entries: {data ? data.length : 0}</p>
                                                            <div className="dropdown col-md-1 p-0 ">
                                                                <button className="btn p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="bi bi-three-dots-vertical"></i>
                                                                </button>
                                                                <ul className="dropdown-menu btn-z-indexer">
                                                                    <li><button className="dropdown-item " type='submit'>Delete Selected</button></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body m-0 p-0">
                                            <div className="table-responsive">
                                                {data !== 0 && header !== 0 ? (
                                                    <table className='table table-bordered tablefontsize' id='dataTable'>
                                                        <thead>
                                                            <tr >
                                                                <th className=' card-header-color  text-dark'><input type="checkbox" checked={isAllChecked} onChange={handleCheckAll} name="" id="" /></th>
                                                                <th className='slnowidth  card-header-color  text-dark'><span>SL NO</span></th>
                                                                {header.map(headerItem => (
                                                                    <th key={headerItem.key} style={{ minWidth: calculateWidth(headerItem.value) }} className='card-header-color text-dark'>{headerItem.value}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data ? (
                                                                <>
                                                                    {data.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td><input type="checkbox" name="" id="" checked={checkedItems[item.id] || false} onChange={() => handleCheckChange(item.id)} /></td>
                                                                            <td>{index + 1}</td>
                                                                            {header.map(headerItem => (
                                                                                <td key={headerItem.key}>
                                                                                    {item[headerItem.key]}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                            ) : (
                                                                <tr>
                                                                    no data
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <h1>no data</h1>
                                                )}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <Dialog
                            open={opendeletemultialert}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle>{"Are you sure?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    Are you sure you want to delete ? This action cannot be undone.

                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handledeletemultiClosealert}>No</Button>
                                <Button onClick={selectedDelete}>Yes</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div> */}
            {createData ? 
            // <ImportFileform
            //     setFiledata={setFile}
            //     title={'Attendance Override'}
            //     filestemp={files}
            //     handleFileUpload={handleFileUpload}
            // />
            <ImportFileformInputMatrix
                setFiledata={setFile}
                title={'Attendance Override'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                date={date}
                File={file}
            />:<ImportFileformInputMatrixclientData
                date={date}
                
            />
            }
            
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Attendance Override'}
            data={data}
            // setEditableRow={setEditableRow}
            // setEditedValues={setEditedValues}
            // handledeleteClickOpenalert={handledeleteClickOpenalert}
            // editableRow={editableRow}
            setLoading={setLoading}
            // editedValues={editedValues}
            getEditPermission = {false}
            getDeletePermission = {false}
            date={date}
            submitdelete={submitdelete}
            // handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#ff9066"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}

export default AttendanceOverride
